// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DeliveryFormFooter-module-button-NChvE{max-width:180px}.DeliveryFormFooter-module-text-ujh9Z{margin-top:10px;font-size:16px;letter-spacing:0;line-height:23px;text-align:center}@media(min-width: 960px){.DeliveryFormFooter-module-text-ujh9Z{text-align:start}}.DeliveryFormFooter-module-notText-nhkXf{font-weight:var(--weight-medium)}.DeliveryFormFooter-module-subText-kTWV2{font-size:12px;font-weight:var(--weight-light);letter-spacing:0;line-height:23px;max-width:500px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "DeliveryFormFooter-module-button-NChvE",
	"text": "DeliveryFormFooter-module-text-ujh9Z",
	"notText": "DeliveryFormFooter-module-notText-nhkXf",
	"subText": "DeliveryFormFooter-module-subText-kTWV2"
};
export default ___CSS_LOADER_EXPORT___;
